import { useEffect, useState } from 'react';
import { useJobTaskApi } from '../../../clients/quipli-service/job-tasks/job-task-api';
import { SelectForm } from '../../../components/select-form/select-form';
import { JobConfig, JobType } from '../../../clients/quipli-service/job-tasks/job-tasks';
import { toast } from '../../../util/toasts';
import { Spinner } from '../../../components/spinner/spinner';

export const AssignInspectionWorkflow = ({
  entity,
  entityId,
  jobType,
}: {
  entity: 'Product' | 'Category';
  entityId?: number;
  jobType: JobType;
}) => {
  const { getProductCategoryJobConfig, setProductCategoryJobConfig, listJobConfigs } = useJobTaskApi();
  const [jobConfigs, setJobConfigs] = useState<JobConfig[]>();
  const [selectedJobConfigId, setSelectedJobConfigId] = useState<string>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        setIsLoading(true);
        const jc = await listJobConfigs();
        setJobConfigs(
          jc.filter((c) => {
            return c.jobType == jobType;
          }),
        );

        if (entityId) {
          const selected = await getProductCategoryJobConfig(entity, entityId, jobType);
          setSelectedJobConfigId(selected?.jobConfigId);
        }
      } catch (e) {
        toast('Error loading inspection workflow settings', 'error');
      } finally {
        setIsLoading(false);
      }
    };
    init();
  }, []);

  const saveInspectionWorkflow = async (jobConfigId?: string) => {
    if (!entityId) {
      return;
    }
    try {
      await setProductCategoryJobConfig(entity, entityId, jobConfigId, jobType);
      setSelectedJobConfigId(jobConfigId);
    } catch (e) {
      console.error(e);
      toast('Error updating inspection workflow setting', 'error');
    }
  };
  return jobConfigs && !isLoading ? (
    <SelectForm
      options={jobConfigs}
      value={jobConfigs.find((jc) => jc.id == selectedJobConfigId)}
      getOptionLabel={(jc) => jc.name}
      getOptionValue={(jc) => jc.id}
      onChange={(v) => saveInspectionWorkflow(v?.id)}
      isClearable={true}
      isDisabled={!entityId}
    />
  ) : (
    <Spinner />
  );
};
